<template>
    <div class="order">
        <div class="luck-btn flex_between"> 
            <div class="flex" style="align-items: center;">
                <p>现金流量表-</p>
                <p style="color:#409EFF;">截止{{endDate}}</p>
            </div>
            <div><span>单位：辆/元</span></div>
            
        </div>
        <div id="luckysheet" v-loading="loading"
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)">
        
        </div>
    </div>
</template>
<script>
import { mc,merge,firstHeader,indexOne, saleHeader,border } from '@/assets/js/xjll'
// import { getIndexArrOne,getRC,getIndexArrMonth} from '@/util/getTableData';
export default {
    props:{
        data:{
            type:Object,
            default:{}
        },
        sdate:{
            type:String,
            default:''
        },
        edate:{
            type:String,
            default:''
        },
       
    },
    data(){
        return{
            edited:[],
            canEdit:[],
            // tableLength:0,
            tableData:this.data,
            date:[],
            endDate:'',
            mydata:[],
            loading:false,
            options:{},
            
        }
    },
    mounted(){
        let _this = this
        this.options = {
                container: 'luckysheet', //容器id名
                title: '现金流量表', // 表 头名
                lang: 'zh', // 中文
                showtoolbar: false, // 是否显示工具栏
                showinfobar: false, // 是否显示顶部信息栏
                showsheetbar:false,
                // showstatisticBar:false,
                enableAddRow:false,
                sheetFormulaBar:false,
                enableAddRow:false,
                enableAddBackTop:false,
                accuracy:0,
                cellRightClickConfig:{
                    
                    copy: false, // 复制
                    copyAs: false, // 复制为
                    paste: false, // 粘贴
                    insertRow: false, // 插入行
                    insertColumn: false, // 插入列
                    deleteRow: false, // 删除选中行
                    deleteColumn: false, // 删除选中列
                    deleteCell: false, // 删除单元格
                    hideRow: true, // 隐藏选中行和显示选中行
                    hideColumn: true, // 隐藏选中列和显示选中列
                    rowHeight: false, // 行高
                    columnWidth: false, // 列宽
                    clear: false, // 清除内容
                    matrix: false, // 矩阵操作选区
                    sort: false, // 排序选区
                    filter: false, // 筛选选区
                    chart: false, // 图表生成
                    image: false, // 插入图片
                    link: false, // 插入链接
                    data: false, // 数据验证
	                cellFormat: false // 设置单元格格式
                },
                hook: {
                    cellUpdated: function (r, c, oldValue, newValue, isRefresh) {
                        if(isRefresh){
                            if(_this.edited.length>0){
                                const has = _this.edited.filter(item=>item.r==r&&item.c==c)
                                if(has.length>0){
                                    _this.edited.forEach(item=>{
                                        if(item.r==r&&item.c==c){
                                            item.v = newValue.v
                                        }
                                    })
                                }else{
                                    _this.edited.push({r:r,c:c,v:newValue.v})
                                }
                            }else{
                                _this.edited.push({r:r,c:c,v:newValue.v})
                            }
                            _this.edited.forEach(item=>{
                                item.name = window.luckysheet.getCellValue(item.r,3)
                                item.date = window.luckysheet.getCellValue(0,item.c)
                            })
                            _this.$emit('getEditData',_this.edited)
                            window.luckysheet.exitEditMode()
                           
                        }
                    }
                }
               
            }
        let arr = this.edate.split("-")
        this.endDate = arr[0]+'年'+arr[1]+'月'
        // this.tableLength = 9+(this.data.capitalPlanOtherMethodList.length*5)
        window.luckysheet.exitEditMode();
        window.luckysheet.destroy();
        this.getExcelDate()
        const scrollview = this.$refs['scrollview']
        // 移除监听
        scrollview.removeEventListener('scroll', this.scrollChange, true)
        // this.handleTest()
       
    },
    methods:{
        scrollChange () {
            window.luckysheet.exitEditMode()
        },
        // 计算年月
        getExcelDate(){
            let sy= Number(this.sdate.split("-")[0]);
            let ey= Number(this.edate.split("-")[0]);
            let sm = Number(this.sdate.split("-")[1]);
            let em = Number(this.edate.split("-")[1]);

            let y ;
            let date = []
            if(sy==ey){//同一年
                if(em>sm){
                    for(let i=sm;i<=em;i++){
                        date.push(`${sy}年${i}月`)
                    }
                }else if(em==sm){
                    date.push(`${ey}年${em}月`)
                }else{
                    this.$DonMessage.warning("结束日期必须在开始日期之后")
                }
            }else if(ey>sy){//不同年
                y = ey-sy
                if(y==1){// 没有间隔的一整年
                    for(let i=sm;i<=12;i++){
                        date.push(`${sy}年${i}月`)
                    }
                    for(let j=1;j<=em;j++){
                        date.push(`${ey}年${j}月`)
                    }
                }
                if(y>1){//中间有完整一整年
                    let fwy = sy+1
                    let lwy = ey-1
                    for(let i=sm;i<=12;i++){
                        date.push(`${sy}年${i}月`)
                    }
                    for(let year=fwy;year<=lwy;year++){
                        for(let month=1;month<=12;month++){
                            date.push(`${year}年${month}月`)
                        } 
                    }
                    for(let j=1;j<=em;j++){
                        date.push(`${ey}年${j}月`)
                    }
                }

            }else{
                this.$DonMessage.warning("结束日期必须在开始日期之后")
            }
            this.date = date
            this.handleTest()
        },
        demo(){
           
            
            if(this.mydata[0].celldata.length>0){
                window.luckysheet.destroy();
                
                this.options.data = this.mydata;
                window.luckysheet.create(this.options);
                
                this.$store.state.excelLoading = false
                window.luckysheet.setRangeShow({ row:[0], column:[0] }, {
                    show: false, // 选中状态不要高亮
                })
                
                window.luckysheet.setRangeFormat("bg", '#E3F2D9', {range:["B12:EX12","B16:EX16","B19:EX20"]})
                window.luckysheet.setRangeFormat("bg", '#195c96', {range:["A9:EX9"]})
            }
        },
        handleTest(){
            this.mydata = [
                {   
                    name: "这个是sheet1",
                    celldata: [],
                    frozen:{
                       type: 'rangeBoth',
                       range: {row_focus: 0, column_focus: 3}
                    },
                   
                    config: {
                        authority:{// 当前工作表的权限配置
                            sheet: 1, // sheet表下标。
                            hintText: "这部分不可以进行修改", // 弹

                            allowRangeList: [
                            	{ sqref: '$G$19:$GX$20' },//设置A2~D6为可编辑区域，其它区域不可编辑
                                // { sqref: '$E$2:$E$20' },
                                { sqref: '$G$16:$EX$16' },
                                { sqref: '$G$12:$EX$12' },
                               
                            ],
                        },
                        borderInfo: [...border],
                    },
                    
                    
                    
                },
            ];
            this.mydata[0].celldata = [...mc]
            // 合并配置
            this.mydata[0].config.merge = merge
            // 年月数据
            if(this.date.length>0){
                this.date.map((item,index)=>{
                    this.mydata[0].celldata.push(
                        {
                            r:0,
                            c:index+6,
                            v:{
                                bg:"#195c96",
                                bl: 1, 
                                v:item,
                                ht:0,
                                fc:'#fff'
                            },

                        }
                    )
                })
                let columns = 5+this.date.length
                for(let i = 0;i<=columns;i++){
                    this.mydata[0].celldata.push(
                        {
                            r:8,
                            c:i,
                            v:{
                                bg:"#195c96",
                                
                            },

                        }
                    )
                }
            }
            // 表头数据项
            firstHeader.map((item,index)=>{
                this.mydata[0].celldata.push(
                    {
                        r:0,
                        c:index,
                        v:{
                            bg:"#195c96",
                            bl: 1, 
                            v:item,
                            ht:0,
                            fc:'#fff'
                        },
                        
                    }
                )
            })
            // 添加序号数据项
            indexOne.map((item,index)=>{
                
                if(item.indexOf('.')==-1){
                        
                        this.mydata[0].celldata.push(
                            {
                                r:index+1,
                                c:2,
                                v:item,
                                v:{
                                    v:item,
                                    ht:0
                                },


                            }
                        )
                        
                    }else{
                        this.mydata[0].celldata.push(
                            {
                                r:index+1,
                                c:2, 
                                v:{ 
                                    v:item,
                                    ht:2
                                },
                            }
                        )
                    }
            })
            // 添加销量项目名
            saleHeader.map((item,index)=>{
                this.mydata[0].celldata.push(
                    {
                        r:index+1,
                        c:3,
                        v:{
                            v:item,
                            ht:0
                        },
                    }
                )
            })
            this.fillData()
            
        },
        fillData(){
            let obj1 = this.tableData.cashFlowStandard//标准
            let obj2 = this.tableData.cashFlowActual
            this.mydata[0].celldata.push(
                {
                    r:1,
                    c:5,
                    v:{ 
                        v:obj1.cashInflowSubtotalSum,
                        ht:0
                    },
                },
                {
                    r:2,
                    c:5,
                    v:{ 
                        v:obj1.salesRevenueSum,
                        ht:0
                    },
                },
                {
                    r:3,
                    c:5,
                    v:{ 
                        v:obj1.cashOutflowSubtotalSum,
                        ht:0
                    },
                },
                {
                    r:4,
                    c:5,
                    v:{ 
                        v:obj1.currentMonthGoodsPaymentSum,
                        ht:0
                    },
                },
                {
                    r:5,
                    c:5,
                    v:{ 
                        v:obj1.currentMonthExpensePaymentSum,
                        ht:0
                    },
                },
                {
                    r:6,
                    c:5,
                    v:{ 
                        v:obj1.currentNetCashFlowSum,
                        ht:0
                    },
                },
                {
                    r:7,
                    c:5,
                    v:{ 
                        v:obj1.cumulativeNetCashFlowSum,
                        ht:0
                    },
                },
                {
                    r:9,
                    c:5,
                    v:{ 
                        v:obj2.cashInflowSubtotalSum,
                        ht:0
                    },
                },
                {
                    r:10,
                    c:5,
                    v:{ 
                        v:obj2.salesRevenueSum,
                        ht:0
                    },
                },
                {
                    r:12,
                    c:5,
                    v:{ 
                        v:obj2.cashOutflowSubtotalSum,
                        ht:0
                    },
                },
                
                {
                    r:13,
                    c:5,
                    v:{ 
                        v:obj2.currentMonthGoodsPaymentSum,
                        ht:0
                    },
                },
                {
                    r:14,
                    c:5,
                    v:{ 
                        v:obj2.currentMonthExpensePaymentSum,
                        ht:0
                    },
                },
                {
                    r:16,
                    c:5,
                    v:{ 
                        v:obj2.currentNetCashFlowSum,
                        ht:0
                    },
                },
              
                {
                    r:11,
                    c:5,
                    v:{ 
                        v:obj2.otherAdjustmentOneSum,
                        ht:0
                    },
                },
                {
                    r:15,
                    c:5,
                    v:{ 
                        v:obj2.otherAdjustmentTwoSum,
                        ht:0
                    },
                },
                {
                    r:17,
                    c:5,
                    v:{ 
                        v:obj2.cumulativeNetCashFlowSum,
                        ht:0
                    },
                },
               
            )
            obj1.cashInflowSubtotal.map((item,i)=>{
                this.mydata[0].celldata.push(
                    {
                        r:1,
                        c:6+i,
                        v:{ 
                            v:item,
                            ht:0
                        },
                    },
                )
            })
            obj1.salesRevenue.map((item,i)=>{
                this.mydata[0].celldata.push(
                    {
                        r:2,
                        c:6+i,
                        v:{ 
                            v:item,
                            ht:0
                        },
                    },
                )
            })
            obj1.cashOutflowSubtotal.map((item,i)=>{
                this.mydata[0].celldata.push(
                    {
                        r:3,
                        c:6+i,
                        v:{ 
                            v:item,
                            ht:0
                        },
                    },
                )
            })
            obj1.currentMonthGoodsPayment.map((item,i)=>{
                this.mydata[0].celldata.push(
                    {
                        r:4,
                        c:6+i,
                        v:{ 
                            v:item,
                            ht:0
                        },
                    },
                )
            })
            obj1.currentMonthExpensePayment.map((item,i)=>{
                this.mydata[0].celldata.push(
                    {
                        r:5,
                        c:6+i,
                        v:{ 
                            v:item,
                            ht:0
                        },
                    },
                )
            })
            obj1.currentNetCashFlow.map((item,i)=>{
                this.mydata[0].celldata.push(
                    {
                        r:6,
                        c:6+i,
                        v:{ 
                            v:item,
                            ht:0
                        },
                    },
                )
            })
            obj1.cumulativeNetCashFlow.map((item,i)=>{
                this.mydata[0].celldata.push(
                    {
                        r:7,
                        c:6+i,
                        v:{ 
                            v:item,
                            ht:0
                        },
                    },
                )
            })
            obj2.cashInflowSubtotal.map((item,i)=>{
                this.mydata[0].celldata.push(
                    {
                        r:9,
                        c:6+i,
                        v:{ 
                            v:item,
                            ht:0
                        },
                    },
                )
            })
            obj2.salesRevenue.map((item,i)=>{
                this.mydata[0].celldata.push(
                    {
                        r:10,
                        c:6+i,
                        v:{ 
                            v:item,
                            ht:0
                        },
                    },
                )
            })
            // 其他调整项1
            obj2.otherAdjustmentOne.map((item,i)=>{
                this.mydata[0].celldata.push(
                    {
                        r:11,
                        c:6+i,
                        v:{ 
                            v:item,
                            ht:0
                        },
                    },
                )
            })
            obj2.cashOutflowSubtotal.map((item,i)=>{
                this.mydata[0].celldata.push(
                    {
                        r:12,
                        c:6+i,
                        v:{ 
                            v:item,
                            ht:0
                        },
                    },
                )
            })
            obj2.currentMonthGoodsPayment.map((item,i)=>{
                this.mydata[0].celldata.push(
                    {
                        r:13,
                        c:6+i,
                        v:{ 
                            v:item,
                            ht:0
                        },
                    },
                )
            })
            // currentMonthExpensePayment
            obj2.currentMonthExpensePayment.map((item,i)=>{
                this.mydata[0].celldata.push(
                    {
                        r:14,
                        c:6+i,
                        v:{ 
                            v:item,
                            ht:0
                        },
                    },
                )
            })
            obj2.otherAdjustmentTwo.map((item,i)=>{
                this.mydata[0].celldata.push(
                    {
                        r:15,
                        c:6+i,
                        v:{ 
                            v:item,
                            ht:0
                        },
                    },
                )
            })
            obj2.currentNetCashFlow.map((item,i)=>{
                this.mydata[0].celldata.push(
                    {
                        r:16,
                        c:6+i,
                        v:{ 
                            v:item,
                            ht:0
                        },
                    },
                )
            })
            obj2.cumulativeNetCashFlow.map((item,i)=>{
                this.mydata[0].celldata.push(
                    {
                        r:17,
                        c:6+i,
                        v:{ 
                            v:item,
                            ht:0
                        },
                    },
                )
            })
           
           
            obj2.cashInflowAdjustmentDescription.map((item,i)=>{
                this.mydata[0].celldata.push(
                    {
                        r:18,
                        c:6+i,
                        v:{ 
                            v:item,
                            ht:0
                        },
                    },
                )
            })
            obj2.cashOutflowAdjustmentDescription.map((item,i)=>{
                this.mydata[0].celldata.push(
                    {
                        r:19,
                        c:6+i,
                        v:{ 
                            v:item,
                            ht:0
                        },
                    },
                )
            })
            
            this.demo()
        }
    },
    beforeDestroy(){
        window.luckysheet.exitEditMode();
        window.luckysheet.destroy();
        const scrollview = this.$refs['scrollview']
        // 移除监听
        scrollview.removeEventListener('scroll', this.scrollChange, true)
    },
}
</script>
<style lang="scss" scoped>
.order{
    min-height:calc(100vh - 100px);
    overflow: hidden;
    position: relative;
    #luckysheet{
        margin:0px;
        padding:0px;
        position:absolute;
        width:98%;
        box-sizing: border-box;
        left: 0px;
        top: 82px;
        bottom:0px;
        height: 88%;
    }
    .luck-btn{
        width: 100%;
        background: #fff;
        padding: 6px;
        box-sizing: border-box;
        margin-top: 50px;
        p{
            font-size: 14px;
            color: #333;
            font-weight: bold;
            margin-right: 10px;
        }
        span{
            font-size: 12px;
            
        }
    }

}
</style>